import { SidePanel } from "components/designV2/sidePanel/sidePanel";
import { useCloseOnEscape } from "hooks/useCloseOnEscape";
import { useTranslation } from "react-i18next";
import type {
  GroupByOption,
  IntervalOption,
  SizeOption,
} from "../hooks/useScheduleToolbarFilters";
import {
  HiddenRadio,
  RadioControl,
  RadioGroup,
  RadioLabel,
  RadioOption,
  Section,
  SectionDescription,
  SectionTitle,
} from "./scheduleOptionsPanel.styled";

interface ScheduleOptionsPanelProps {
  isOpen: boolean;
  intervalOption: IntervalOption;
  groupByOption: GroupByOption;
  sizeOption: SizeOption;
  onGroupByChange: (value: GroupByOption) => void;
  onSizeChange: (value: SizeOption) => void;
  onClose: () => void;
}

export const ScheduleOptionsPanel = (
  props: ScheduleOptionsPanelProps,
): JSX.Element | null => {
  const { t } = useTranslation();

  useCloseOnEscape({
    isOpen: props.isOpen,
    onClose: props.onClose,
    stopPropagation: true,
  });

  return (
    <SidePanel
      isOpen={props.isOpen}
      onClose={props.onClose}
      title={t("Schedule.Options")}
    >
      <Section>
        <SectionTitle>{t("Schedule.GroupBy")}</SectionTitle>
        <SectionDescription>
          {t("Schedule.GroupByDescription")}
        </SectionDescription>
        <RadioGroup role="radiogroup" aria-label={t("Schedule.GroupBy")}>
          <RadioOption>
            <HiddenRadio
              type="radio"
              name="schedule-group-by"
              checked={props.groupByOption === "team"}
              onChange={() => props.onGroupByChange("team")}
            />
            <RadioControl />
            <RadioLabel>{t("Schedule.Team")}</RadioLabel>
          </RadioOption>
          <RadioOption>
            <HiddenRadio
              type="radio"
              name="schedule-group-by"
              checked={props.groupByOption === "person"}
              onChange={() => props.onGroupByChange("person")}
            />
            <RadioControl />
            <RadioLabel>{t("Schedule.Person")}</RadioLabel>
          </RadioOption>
        </RadioGroup>
      </Section>

      {props.intervalOption === "weekly" && (
        <Section>
          <SectionTitle>{t("Schedule.ScheduleSize")}</SectionTitle>
          <SectionDescription>
            {t("Schedule.ScheduleSizeDescription")}
          </SectionDescription>
          <RadioGroup role="radiogroup" aria-label={t("Schedule.ScheduleSize")}>
            <RadioOption>
              <HiddenRadio
                type="radio"
                name="schedule-size"
                checked={props.sizeOption === "large"}
                onChange={() => props.onSizeChange("large")}
              />
              <RadioControl />
              <RadioLabel>{t("Schedule.Large")}</RadioLabel>
            </RadioOption>
            <RadioOption>
              <HiddenRadio
                type="radio"
                name="schedule-size"
                checked={props.sizeOption === "small"}
                onChange={() => props.onSizeChange("small")}
              />
              <RadioControl />
              <RadioLabel>{t("Schedule.Small")}</RadioLabel>
            </RadioOption>
          </RadioGroup>
        </Section>
      )}
    </SidePanel>
  );
};
